import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 28 24"
  }, props),
  /* @__PURE__ */ React.createElement("rect", { width: 28, height: 24, fill: "#fff", rx: 4 }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M8.145 16.26h5.712v-1.368h-3.444l1.656-1.656c1.044-.984 1.728-1.884 1.728-2.928 0-1.5-1.188-2.568-2.784-2.568-1.632 0-2.94 1.212-2.94 2.94l1.38.072c.012-1.032.6-1.644 1.548-1.644.78 0 1.356.516 1.356 1.236 0 .66-.42 1.152-1.284 2.004L8.145 15.24v1.02Zm11.782 0-2.148-3.036 2.004-2.832H18.2l-1.224 1.716-1.212-1.716h-1.62l2.028 2.844-2.148 3.024h1.596l1.344-1.896 1.356 1.896h1.608Z"
    }
  )
);
var SvgSpeed200XFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var Speed200XFilled_default = SvgSpeed200XFilled;

export { Speed200XFilled_default as default };
